<template>
    <div>
        <div v-if="$route.path.indexOf('_editor') === -1 && $route.path.indexOf('_detail') === -1 ">
            <div class="content-bottom-padded">
                <el-alert type="info" title="操作说明" show-icon >
                    <div> 说明：积分变动只针对兑吧和视频发出和扣除的积分记录，其他积分消耗和增加没有记录。 </div>
                </el-alert>
            </div>
            <el-row :gutter="20">
                <el-col :span="4">
                    <el-input placeholder="用户id" v-model="params.user_id"><el-button slot="append" icon="el-icon-search" @click="numberSearch"></el-button></el-input>
                </el-col>
                <el-col :md="10" :lg="8">
                    <el-date-picker v-model="created" type="daterange" start-placeholder="开始日期" ange-separator="至" end-placeholder="结束日期" value-format="yyyy/MM/dd" placeholder="选择日期范围" style="width: 100%;" @change="dateChange" size="mini"></el-date-picker>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-button-group>
                    </el-button-group>
                </el-col>
            </el-row>
            <el-table :data="list"  :height="wheight-140" v-loading="loading">
                <el-table-column type="selection" align="center" label="全选" ></el-table-column>
                <el-table-column prop="user_id" label="用户id"></el-table-column>
                <el-table-column prop="cardno" label="会员卡号"></el-table-column>
                <el-table-column prop="cardtype" label="会员卡类型"></el-table-column>
                <el-table-column prop="expend" label="积分">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.expend == 1" type="danger" size="mini"> - {{scope.row.points}}</el-tag>
                        <el-tag v-if="scope.row.expend == 0" type="success" size="mini"> + {{scope.row.points}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="source" label="来源"></el-table-column>


                <el-table-column prop="create_time"  label="创建时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.create_time | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="params" label="其他说明"></el-table-column>


            </el-table>
            <div v-if="total_count > params.pageSize" class="content-padded content-center">
                <el-pagination
                        background
                        layout="prev, pager, next"
                        @current-change="handleCurrentChange"
                        :current-page.sync="params.page"
                        :total="total_count" :page-size="params.pageSize">
                </el-pagination>
            </div>
            <el-dialog title="详情" :visible.sync="realTimeDialog" :before-close="handleGetRealTimePoint" width="57%">
                <template>
                    <el-row :gutter="100">
                        <el-col :span="24">
                            附加参数:{{realTimeData}}
                        </el-col>
                    </el-row>

                </template>
                <div slot="footer" class="dialog-footer">
                    <el-button @click.native="handleGetRealTimePoint">确定</el-button>
                </div>
            </el-dialog>


        </div>
        <router-view></router-view>
    </div>
</template>
<script>

    import { mapGetters } from 'vuex'

    import { getPointList} from '../../../api/duiba'

    export default {
        data () {
            return {
                editTitleCategroy: '',
                editCategroyVisible:false,
                CategoryList:[],
                office_area_name:[],
                office_area_id:'',
                loadingCategoryF: false,
                submitLoading:false,
                dialogVisible: false,
                time_start_begin: '',
                time_start_end: '',
                created:'',
                changeStatus: true,
                activeName: 'first',
                total_count: 0,
                detailDialog: false,
                pcDialogVisible: false,
                dialogTitle: '',
                select_tags_value: '',
                loading: false,
                params: {
                    page: 1,
                    pageSize: 20,
                    user_id: '',
                    time_start_begin : '',
                    time_start_end :''
                },
                // 详情
                realTimeDialog:false,
                realTimeData:'查询中...',
                realTimePointparams:{
                    user_id:'',
                    cardno:''
                },
                form: {
                    distributor_id: null,
                    mobile: '',
                    address: '',
                    name: '',
                    is_valid: 'true',
                    regions_id: [],
                    regions: [],
                    shop_id: 0,
                    contact: ''
                },
                list: [],
                rowdata: {},
                downDistributorVal: false,
                distributor_id: [],
                tag: {
                    dialog: false,
                    editItem: [],
                    list: [],
                    form: {
                        tag_ids: [],
                        distributor_id: []
                    },
                    currentTags: [],
                    tags: []
                },
                chooseCat:[],
                checkAll:false  //全选的v-model值
            }
        },
        components: {  },
        computed: {
            ...mapGetters([
                'wheight'
            ])
        },
        methods: {
            closeDialog () {
                this.dialogVisible = false
                this.pcDialogVisible = false
            },
            isValidSelectHandle () {
                this.params.page = 1
                this.getList()
            },

            numberSearch (e) {
                this.params.page = 1
                this.getList()
            },
            dateChange (val) {
                console.log(val)

                if (val.length > 0) {
                    this.time_start_begin = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
                    this.time_start_end = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
                    this.params.time_start_begin = this.time_start_begin
                    this.params.time_start_end = this.time_start_end
                } else {
                    this.time_start_begin = ''
                    this.time_start_end = ''
                    this.params.time_start_begin = ''
                    this.params.time_start_end = ''
                }
                this.params.page = 1

                this.getList()
            },
            dateStrToTimeStamp (str) {
                return Date.parse(new Date(str))/1000
            },
            handleCurrentChange (page_num) {
                this.params.page = page_num
                this.getList()
            },
            dialogOpen (detail = null) {
                this.$router.push({path: this.matchHidePage('editor')})
            },
            getList () {
                this.loading = true
                console.log(this.params)

                getPointList(this.params).then(response => {
                    if (response.data.data.list) {
                        this.list = response.data.data.list
                        this.total_count = response.data.data.total_count
                    }
                    this.loading = false
                })
            },
            // 查看详情
            getRealTimePoint(params){
                this.realTimeData = params ? params : '暂无'
                this.realTimeDialog = true
            },
            handleGetRealTimePoint(){
                this.realTimeDialog = false
                this.realTimePointparams.user_id = ''
                this.realTimePointparams.cardno = ''
                this.realTimeData = '查询中...'
            },

            // 更新默认卡
            changeUserDefaultCard(user_id,cardno,mobile){
                this.$confirm('是否更新为默认卡', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {user_id:user_id,cardno:cardno,mobile:mobile}
                    changeUserDefaultCard(params).then(response => {
                        let changestatus = response.data.data.status

                        if (changestatus) {
                            this.$message.success('更新成功!')
                            return false
                        }else{
                            this.$message.error('更新失败')
                            return false
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消操作'
                    });
                });
            },
            handleCancel () {
                this.editCategroyVisible=false
            },
            handleCancelLabelsDialog() {
                this.tag.dialog = false
            },
        },
        mounted () {
            this.getList()
        }
    }
</script>

<style lang="scss" scoped>
    .tag-users {
        padding-bottom: 10px;
        line-height: 1.2;
        .icon-user-circle1 {
            margin-right: 10px;
            font-size: 24px;
            color: #ccc;
        }
    }
    .selected-tags {
        padding-top: 15px;
        margin-bottom: 15px;
        border-top: 1px solid #efefef;
        border-bottom: 1px solid #efefef;
        .label {
            margin-bottom: 15px;
        }
        .el-tag {
            margin-right: 10px;
            margin-bottom: 15px;
        }
    }
    .tag-item {
        cursor: pointer;
        color: #666;
        border-color: #dadadd;
        margin-right: 10px;
        margin-top: 10px;
    }
</style>



// WEBPACK FOOTER //
// list.vue?651075ef